export default {
      id: "i-gid-usage",
      viewBox: "0 0 32 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-gid",
      toString: function () {
        return this.url;
      }
    }